import { render } from "./ProfileDashboard.vue?vue&type=template&id=3a330a0c"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__